export default __webpack_public_path__ + "static/media/webpage.7d1ac515.png";